// @flow
import React, { Component, Fragment, type Node } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { type ContextRouter, Link, type Match, withRouter } from 'react-router-dom';
import { MdShoppingCart } from 'react-icons/md';
import { FaHeart } from 'react-icons/fa';
import { AiOutlineMenu } from 'react-icons/ai';

import debounce from 'lodash/debounce';
import { getScrollTop } from 'lib/common';
import { redirectToLogin, redirectToSignup } from 'lib/sso';
import { BaseActions } from 'store/actionCreators';

import UserMobileMenuContainer from 'containers/base/UserMobileMenuContainer';
import Button from 'components/common/Button';
import MainSearchBox from '../MainSearchBox';
import './MainHead.scss';
import type { State } from '../../../store';

type Props = {
  match: Match,
  rightArea: ?Node,
  logged: boolean,
  onBurgerMenuClick(): void,
  closeCategoryMenuBox(): void,
} & ContextRouter;

class MainHead extends Component<Props> {
  onSearch = (keyword: string) => {
    const q = keyword.replace(/&/g, '%26').replace(/\+/g, '%2B');
    this.props.history.push(`/search?q=${q}&menu=products`);
  };

  onCartButtonClick = () => {
    this.props.history.push('/cart');
  };

  onWishButtonClick = () => {
    if (!this.props.logged) {
      BaseActions.showToast({ type: 'error', message: '로그인이 필요합니다.' });
    } else {
      this.props.history.push('/wish');
    }
  };

  onLoginButtonClick = () => {
    redirectToLogin();
  };

  onSignupButtonClick = () => {
    redirectToSignup();
  };

  lastScrollTop: number;

  onScroll = debounce(e => {
    this.lastScrollTop = getScrollTop();
  }, 20);

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, { passive: true });
  }

  render() {
    const { rightArea, location, onBurgerMenuClick, closeCategoryMenuBox, profile } = this.props;
    const isSearch = location.pathname === '/search';
    return (
      <div
        className="MainHead"
        onScroll={this.onScroll}
        onMouseOver={closeCategoryMenuBox}
        onFocus={closeCategoryMenuBox}
      >
        <nav className="nav">
          <div className="burger-menu" onClick={onBurgerMenuClick}>
            <AiOutlineMenu />
          </div>
          <Link to="/" className="mobile-logo">
            <img src="https://images.cacheby.com/logo.svg" alt="CacheBy" />
          </Link>
          <div className="spacer" />
          <div className="search-area">
            <MainSearchBox onSearch={this.onSearch} />
          </div>
          <div className="spacer" />
          <div className="button-area">
            <a onClick={this.onWishButtonClick} className="wish-btn">
              <FaHeart className="wish-icon" />
              <span className="wish-count">{this.props.wish.items.length || 0}</span>
            </a>
          </div>
          <div className="button-area">
            <a onClick={this.onCartButtonClick} className="cart-btn">
              <MdShoppingCart className="cart-icon" />
              <span className="cart-count">{this.props.cart.items.length || 0}</span>
            </a>
          </div>
          <div className="right-area">
            {rightArea || (
              <Fragment>
                <Button theme="outline" onClick={this.onLoginButtonClick}>
                  로그인
                </Button>
                <Button theme="default" onClick={this.onSignupButtonClick}>
                  회원가입
                </Button>
              </Fragment>
            )}
          </div>
        </nav>
        <UserMobileMenuContainer location={location} />
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(
    ({ cart, wish, profile }: State) => ({
      cart,
      wish,
      profile,
    }),
    () => ({}),
  ),
)(MainHead);



// WEBPACK FOOTER //
// ./src/components/main/MainHead/MainHead.js